var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"newDsMailerContainer"}},[_c('datasource-mailer',{on:{"on-save":_vm.handleSave},model:{value:(_vm.datasourceMailer),callback:function ($$v) {_vm.datasourceMailer=$$v},expression:"datasourceMailer"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }